export default __webpack_public_path__ + "static/media/logo-with-paint.e8db3e9b.png";